import type { InternalAxiosRequestConfig } from 'axios';
import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';

export const useRequestStore = defineStore('requests', () => {
  const requests = reactive<Map<string, InternalAxiosRequestConfig>>(new Map());

  const loadingInProgress = computed(() => {
    return requests.size > 0;
  });

  function addRequest(request: InternalAxiosRequestConfig) {
    const fullUrl
      = request.url + (request.params?.toString() ? `?${request.params.toString()}` : '');
    requests.set(fullUrl, request);
  }

  function removeRequest(url: string) {
    requests.delete(url);
  }

  return { requests, loadingInProgress, addRequest, removeRequest };
});
